


import React, {useState,useEffect} from 'react';
import NavBar from '../NavBar/NavBar';
import "./HeroSection.css"
import useContentful from '../../Hooks/Contentful';
import img1 from "../Images/Alcon1.jpg"



function HeroSection() { 


      
  const {getPosters} = useContentful()
  const [cardData, setCardData] = useState()
 

      
 useEffect(() => {
     console.log("Hello")
  
   getPosters().then((response) => response && setCardData(response));
 //   getPosters().then((response) => response && console.log("hero",response));
 },[]);
 

  return <>
    <div className='HeroSectionWhole'

        style={{
          // width: 128,
          // height: 193,
          backgroundImage: `url(${(cardData && cardData.length>0 && cardData[0]?.image?.fields?.file?.url) || (img1) })`
        }}

    
    >
        
            <NavBar/>

        
                
    </div>
  
  </>
  
  ;
}

export default HeroSection;